import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from '../components/ConfigContext';
import Cookies from 'js-cookie';
import { Box, Card, CardContent, Grid2 as Grid, Typography, Button } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { constants } from '../constants';
import DefaultAppImage from '../../public/StudioConCON.svg';
var getApplicationDesc = function getApplicationDesc(appId) {
    switch (appId) {
        case 'forecasting':
            return 'Forecast what’s next—and why. Creates high-accuracy, explainable forecasts at scale. Feeds into planning, revenue management, inventory, and labor decisions.';
        case 'assortment':
            return 'Put the right product in the right place, profitably. Optimizes product and place decisions using demand forecasts, constraints, and transferability intelligence.';
        case 'storeClustering':
            return 'Segment stores by what actually matters. Uses GenAI and clustering to group stores by what drives decisions—enabling localized assortment, pricing, labor, and marketing.';
        case 'featureFoundry':
            return 'Feature engineering asset that automates feature extraction, transformation, and selection to accelerate model development and improve predictive performance.';
        default:
            return "Access the ".concat(appId, " application to explore its features and capabilities.");
    }
};
// Dynamic product data based on environment variables
var getProductsFromEnv = function getProductsFromEnv() {
    var productsString = process.env.REACT_APP_PRODUCTS || '';
    var urlsString = process.env.REACT_APP_PRODUCT_URLS || '';
    var productsAppName = process.env.REACT_APP_NAME || '';
    var productIds = productsString.split(',').map(function (id) {
        return id.trim();
    }).filter(Boolean);
    var productUrls = urlsString.split(',').map(function (url) {
        return url.trim();
    }).filter(Boolean);
    var productApps = productsAppName.split(',').map(function (name) {
        return name.trim();
    }).filter(Boolean);
    return productIds.map(function (id, index) {
        return {
            id: id,
            title: productApps[index] || id,
            description: getApplicationDesc(id),
            url: productUrls[index] || '#',
            hasNotifications: false,
            notificationCount: 0
        };
    });
};
var ProductCard = function ProductCard(_ref) {
    var product = _ref.product, onClick = _ref.onClick;
    var handleClick = function handleClick() {
        onClick(product.id, product.url);
    };
    return /*#__PURE__*/ React.createElement(Card, {
        sx: {
            height: 307,
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid #d9d9d9',
            borderRadius: 2,
            boxShadow: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            maxHeight: 135,
            minHeight: 135,
            backgroundColor: '#F5F5F5',
            borderRadius: '8px 8px 0 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: DefaultAppImage,
        alt: 'Default App',
        style: {
            height: '100%',
            width: '100%',
            objectFit: 'cover'
        }
    })), /*#__PURE__*/ React.createElement(CardContent, {
        sx: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            padding: '16px !important'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "#121212",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, product.title), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "#595959",
        sx: {
            mb: 2,
            minHeight: 40,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
        },
        title: product.description
    }, product.description), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'flex-start'
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        onClick: handleClick,
        endIcon: /*#__PURE__*/ React.createElement(OpenInNewIcon, null),
        sx: {
            textTransform: 'none',
            boxShadow: 'none'
        }
    }, constants.open))));
};
var ProductSelection = function ProductSelection() {
    var navigate = useNavigate();
    var _useContext = useContext(ConfigContext), configState = _useContext.configState, setConfigState = _useContext.setConfigState;
    // Get products from environment variables
    var products = getProductsFromEnv();
    var handleProductClick = function handleProductClick(productId) {
        // Update the config state with selected product
        var temp = JSON.parse(JSON.stringify(configState));
        temp.selectedProduct = productId;
        setConfigState(temp);
        // Set cookie for selected product
        Cookies.set('Product Selected', productId, {
            secure: true,
            sameSite: 'Strict'
        });
        // For navigation, use the productId for internal routing
        // The button click will handle opening the external URL
        navigate("/".concat(productId));
    };
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 3
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: "#212121",
        sx: {
            mb: 3
        }
    }, constants.your_apps), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flexGrow: 1,
            overflow: 'auto',
            // Enable vertical scroll when needed
            maxHeight: 'calc(100vh - 280px)' // Limit height to ensure scroll works
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2,
        sx: {
            justifyContent: 'flex-start',
            maxWidth: '100%',
            margin: 0,
            pb: 2 // Add some padding at bottom
        }
    }, products.map(function (product) {
        return /*#__PURE__*/ React.createElement(Grid, {
            key: product.id,
            size: {
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
            }
        }, /*#__PURE__*/ React.createElement(ProductCard, {
            product: product,
            onClick: handleProductClick
        }));
    }))));
};
export default ProductSelection;
